import { useRef, useState } from "react";
import api from "../lib/api";
import { Loader2, Search } from "lucide-react";

// Autocomplete per collegare la pratica corrente a un'altra (ricerca numero/nominativo).
export default function CollegaPraticaField({ currentId, currentNumero, onSelect }) {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const timer = useRef(null);

  const search = (val) => {
    setQ(val);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      const qq = (val || "").trim();
      if (qq.length < 2) { setItems([]); setOpen(false); return; }
      setLoading(true); setOpen(true);
      try {
        const { data } = await api.get(`/studio/pratiche-search?q=${encodeURIComponent(qq)}`);
        setItems((data || []).filter((r) => r.id !== currentId && r.numero_pratica !== currentNumero));
      } catch { setItems([]); } finally { setLoading(false); }
    }, 250);
  };
  const pick = (pr) => { setQ(""); setItems([]); setOpen(false); onSelect(pr); };

  return (
    <div className="relative">
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-mono mb-1">Collega a pratica</div>
      <div className="relative">
        <Search className="h-3.5 w-3.5 text-slate-500 absolute left-2 top-1/2 -translate-y-1/2 pointer-events-none" />
        <input value={q} onChange={(e) => search(e.target.value)} placeholder="Cerca numero o nominativo…" data-testid="collega-input"
          className="w-full h-8 rounded-md bg-slate-900/60 border border-slate-700 text-slate-100 text-xs pl-7 pr-2 focus:outline-none focus:ring-1 focus:ring-indigo-500/40" />
      </div>
      {open && (
        <div className="absolute left-0 right-0 mt-1 z-50 rounded-md border border-slate-700 bg-[#0d1220] shadow-xl max-h-48 overflow-y-auto" data-testid="collega-suggestions">
          {loading ? (
            <div className="px-2 py-2 text-center"><Loader2 className="h-4 w-4 animate-spin text-indigo-400 inline" /></div>
          ) : items.length === 0 ? (
            <div className="px-2 py-2 text-xs text-slate-500">Nessuna pratica trovata.</div>
          ) : items.map((pr) => (
            <button key={pr.id} type="button" onClick={() => pick(pr)} data-testid="collega-suggestion"
              className="w-full text-left px-2 py-1.5 hover:bg-slate-800/70 border-b border-slate-800 last:border-0">
              <span className="font-mono text-amber-400 text-xs">{pr.numero_pratica || "—"}</span>
              {pr.nome_assistito ? <span className="text-slate-300 text-xs"> · {pr.nome_assistito}</span> : null}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
